import React from 'react';
import ReactDOM from 'react-dom/client';
import AppAuthWithIdToken from './auth/AppAuthWithIdToken';
import AuthCallback from './auth/AuthCallback';
import LogoutRoute from './auth/LogoutRoute';
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import { Auth0ProviderWithHistory } from "./auth/auth0-provider-with-history";
import { CompanyProvider } from './auth/CompanyContext';
import { IdTokenProvider } from "./auth/IdTokenContext";
import { CRMProvider } from './auth/CRMContext';
import './index.css';

const origWarn = console.error;
console.error = (...args) => {
    if (
        typeof args[0] === "string" &&
        args[0].includes("Support for defaultProps will be removed")
    ) return;
    origWarn(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const RootRoutes = () => {
    const { pathname } = useLocation();
    const isAuthRoute = pathname === "/callback" || pathname === "/logout";

    return (
        <>
            <Switch>
                <Route path="/callback" component={AuthCallback} />
                <Route path="/logout" component={LogoutRoute} />
            </Switch>
            {!isAuthRoute && <AppAuthWithIdToken />}
        </>
    );
};

root.render(
    <Router>
        <Auth0ProviderWithHistory>
            <CompanyProvider>
                <IdTokenProvider>
                    <CRMProvider>
                        <RootRoutes />
                    </CRMProvider>
                </IdTokenProvider>
            </CompanyProvider>
        </Auth0ProviderWithHistory>
    </Router>
);
